<template>
    <v-card class="mx-auto" min-width="500">

        <v-card-title class="text-h6 font-weight-regular justify-space-between">
        <span>Επεξεργασία παραστατικού αγοράς</span>
        </v-card-title>

        <v-dialog v-model="selectAccountDialog" max-width="400">
            <v-card class="ma-4" max-width="350" v-bind:key="account.id" v-for="account in selectAccountDialogEntries">
                <v-card-title class="text-wrap">
                    <p>{{account.name}}</p>
                </v-card-title>
              
                <v-card-subtitle>{{ `ΑΦΜ: ${account.tax_registration_number || '-'}` }}</v-card-subtitle>
              
                <v-card-text>
                    <v-container>
                        <v-row>
                            <div>{{account.city}} {{account.zipcode}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.address}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.telephone}}</div>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="updateAccount(selectAccountDialogShownFor, account); closeSelectAcountDialog();">ΕΠΙΛΟΓΗ</v-btn>
                </v-card-actions>
            </v-card>
     
        </v-dialog>
        <!-- ΒΑΣΙΚΑ ΣΤΟΙΧΕΙΑ -->

        <v-window v-model="step">
            <v-window-item :value="0">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Βασικά στοιχεία</h3>
                    
                    <v-select 
                        v-bind:items="documentTypes" 
                        v-model="selectedDocumentType"
                        return-object
                        
                        item-text="description" 
                        label="Είδος παραστατικού"
                        v-bind:error-messages="allerrors.document_type_id">
                    </v-select>

                    <v-text-field 
                        v-model.number="document_number" 
                        label="Αριθμός παραστατικού"
                        v-bind:error-messages="allerrors.document_series"
                        v-bind:hint="duplicateWarning"
                        persistent-hint
                        :error="duplicateWarning !== ''"
                        v-bind:disabled="selectedSeries.autonumbered">
                    </v-text-field>

                    <v-select 
                        v-bind:items="warehouses"
                        v-model="selectedWarehouse"
                        return-object
                        item-text="name"
                        item-value="id" 
                        label="Αποθήκη"
                        v-bind:error-messages="allerrors.document_warehouse">
                    </v-select>

                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="document_issue_date"
                                label="Ημερομηνία έκδοσης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="document_issue_date"
                            @input="menu2 = false">
                        </v-date-picker>
                    </v-menu>


                </v-card-text>
            </v-window-item>



            <!-- ΠΕΛΑΤΗΣ -->

            <v-window-item :value="1">
                <v-card-text>
                    <v-row>
                        <h3 class="text-h6 font-weight-light mb-2">Στοιχεία προμηθευτή</h3>
                        <v-spacer></v-spacer>
                        <v-btn text color="warning" v-on:click="clearSupplierFields">ΚΑΘΑΡΙΣΜΑ</v-btn>
                    </v-row>

                    <v-alert v-if="duplicateWarning !== ''" type="warning" dense text icon="mdi-alert">
                        {{ duplicateWarning }}
                    </v-alert>

                    <v-text-field 
                        v-bind:readonly="supplierNotEditable"
                        v-model="supplier.name" 
                        append-icon="mdi-account-search"
                        @click:append="searchAccountByName('supplier')"
                        v-bind:error-messages="allerrors.supplier.name">
                            <template #label>
                                <span class="red--text"><strong>* </strong></span>Επωνυμία
                            </template>
                    </v-text-field>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-bind:readonly="supplierNotEditable"
                                v-model="supplier.tax_registration_number"
                                label="ΑΦΜ"
                                append-icon="mdi-account-search"
                                @click:append="searchAccountByTaxRegistrationNumber('supplier')"
                                v-bind:loading="disabledTaxRegistrationNumberFields.supplier"
                                v-bind:error-messages="allerrors.supplier.tax_registration_number">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-bind:readonly="supplierNotEditable"
                                v-model="supplier.tax_registration_office_id"
                                v-bind:items="taxOffices" 
                                item-text="name" 
                                item-value="id" 
                                label="ΔΟΥ"
                                v-bind:error-messages="allerrors.supplier.tax_registration_office_id">
                            </v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field 
                                v-bind:readonly="supplierNotEditable"
                                v-model="supplier.jobtitle" 
                                label="Επάγγελμα"
                                append-icon="mdi-account-search"
                                v-bind:error-messages="allerrors.supplier.jobtitle">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-bind:readonly="supplierNotEditable"
                                v-model="supplier.country_id"
                                v-bind:items="countries" 
                                item-text="name_gr" 
                                item-value="id"
                                v-bind:error-messages="allerrors.supplier.country_id">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Χώρα
                                    </template>
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-combobox
                                v-bind:readonly="supplierNotEditable"
                                v-model="supplier.city"
                                v-bind:items="filteredSupplierCities"
                                v-bind:error-messages="allerrors.supplier.city">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Πόλη
                                    </template>
                            </v-combobox>
                        </v-col>
                        
                    </v-row>                    

                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-text-field 
                                v-bind:readonly="supplierNotEditable"
                                v-model="supplier.address" 
                                v-bind:error-messages="allerrors.supplier.address">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Διεύθυνση
                                    </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field 
                                v-bind:readonly="supplierNotEditable"
                                v-model="supplier.zipcode" 
                                label="ΤΚ"
                                v-bind:error-messages="allerrors.supplier.zipcode">
                            </v-text-field>
                        </v-col>
                    </v-row>            

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="supplier.telephone" 
                                label="Αριθμός τηλεφώνου"
                                append-icon="mdi-account-search"
                                v-bind:error-messages="allerrors.supplier.telephone">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="supplier.mobile" 
                                label="Αριθμός κινητού"
                                append-icon="mdi-account-search"
                                v-bind:error-messages="allerrors.supplier.mobile">
                            </v-text-field>
                        </v-col>
                    </v-row>                    


                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="supplier.fax" 
                                label="Αριθμός Φαξ"
                                v-bind:error-messages="allerrors.supplier.fax">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="supplier.email" 
                                label="E-Mail"
                                v-bind:error-messages="allerrors.supplier.email">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-window-item>


            <v-window-item :value="2">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Μερικό σύνολο: {{totalChargedAmount}}</h3>

                    <v-select
                        v-if="selectedDocumentTypeIsPayable"
                        v-bind:items="filteredPaymentTypes" 
                        v-model="selectedPaymentType"
                        return-object
                        
                        item-text="description" 
                        label="Τρόπος πληρωμής"
                        v-bind:error-messages="allerrors.payment_type_id">
                    </v-select>

                   <v-data-table
                        :headers="itemsHeaders"
                        :items="items"
                        sort-by="calories"
                        class="elevation-1"
                        disable-pagination
                        disable-filtering
                        hide-default-footer>
                        
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Εμπορεύματα</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                Σύνολο τεμαχίων: {{totalItemsCount}}
                                <v-spacer></v-spacer>

                                <v-dialog v-model="dialog" max-width="500px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <!-- 
                                            <v-btn color="primary" dark class="mb-2" v-on:click="addPackage">+1 ΔΕΜΑ</v-btn>
                                        -->
                                        <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">ΠΡΟΣΘΗΚΗ</v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" md="8" sm="6">
                                                        <v-checkbox
                                                            label="Επεξεργασία στοιχείων είδους"
                                                            v-model="editedItem.isAdHoc"
                                                            @change="adHocItemStatusChanged"
                                                            />

                                                        <v-autocomplete
                                                            v-bind:items="products"
                                                            v-model="editedItem.product_id"
                                                            auto-select-first
                                                            item-value="id"
                                                            item-text="text"
                                                            label="Είδος"
                                                            @change="productSelected">
                                                        </v-autocomplete>

                                                        <v-text-field
                                                            label="Εκτυπώσιμη περιγραφή"
                                                            v-model="editedItem.override_product_description"
                                                        />

                                                        <v-text-field
                                                            label="Ποσότητα"
                                                            v-model.number="editedItem.quantity"
                                                            track-color="grey"
                                                            always-dirty
                                                            min="0"
                                                            max="100"
                                                            thumb-label="always"
                                                            type="number">

                                                            <template v-slot:prepend>
                                                                <v-icon @click="editedItem.quantity--">mdi-minus </v-icon>
                                                            </template>

                                                            <template v-slot:append>
                                                                <v-icon @click="editedItem.quantity++">mdi-plus</v-icon>
                                                            </template>
                                                        </v-text-field>

                                                        <vuetify-money
                                                            v-model="editedItem.unit_price"
                                                            label="Χρέωση μονάδας"
                                                            v-bind:options="moneyFieldOptions">
                                                        </vuetify-money>

                                                        <v-text-field
                                                            label="Εκπτωση (%)"
                                                            v-model.number="editedItem.discount_percentage"
                                                            track-color="grey"
                                                            always-dirty
                                                            min="0"
                                                            max="100"
                                                            thumb-label="always"
                                                            type="number">
                                                        </v-text-field>

                                                        <!-- <vuetify-money
                                                            v-model="editedItem.discount_percentage"
                                                            label="Εκπτωση (%)"
                                                            v-bind:options="discountFieldOptions">
                                                        </vuetify-money> -->

                                                        <div v-if="editedItem.isAdHoc">
                                                            

                                                            <v-select
                                                                v-bind:items="vatCategories" 
                                                                v-model="editedItem.override_product_vat_category_id"
                                                                item-value="id"
                                                                item-text="description" 
                                                                label="Κατηγορία ΦΠΑ"
                                                                v-bind:error-messages="allerrors.override_product_vat_category_id">
                                                            </v-select>

                                                            <v-select
                                                                v-bind:items="vatExemptionCategories" 
                                                                v-model="editedItem.override_vat_exemption_category_id"
                                                                item-value="id"
                                                                item-text="description" 
                                                                label="Κατηγορία απαλλαγής ΦΠΑ"
                                                                v-bind:error-messages="allerrors.override_vat_exemption_category_id">
                                                            </v-select>

                                                            <v-select
                                                                v-bind:items="measurementUnits" 
                                                                v-model="editedItem.override_product_measurement_unit_id"
                                                                item-value="id"
                                                                item-text="description" 
                                                                label="Μονάδα μέτρησης"
                                                                v-bind:error-messages="allerrors.override_product_measurement_unit_id">
                                                            </v-select>

                                                            <!-- <v-select
                                                                v-bind:items="incomeCategories" 
                                                                v-model="editedItem.override_product_income_category_id"
                                                                item-value="id"
                                                                item-text="description" 
                                                                label="Κατηγορία εσόδου"
                                                                v-bind:error-messages="allerrors.override_product_income_category_id">
                                                            </v-select> -->


                                                        </div>

                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="warning darken-1" text @click="close">ΚΛΕΙΣΙΜΟ</v-btn>
                                            <v-btn color="green darken-1" text @click="save(false)" v-bind:disabled="lineEntryIncomplete">ΠΡΟΣΘΗΚΗ</v-btn>
                                            <v-btn color="blue darken-1" text @click="save(true)" v-bind:disabled="lineEntryIncomplete">ΕΝΤΑΞΕΙ</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>

                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Διαγραφή εγγραφής " {{ editedItem.quantity}} x {{ editedItem.isAdHoc ? editedItem.override_product_description : (editedItem.product ? editedItem.product.description : '') }} ";</v-card-title>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                                            <v-btn color="error darken-1" text @click="deleteItemConfirm">ΕΝΤΑΞΕΙ</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        
                        <template v-slot:[`item.product_code`]="{ item }" >
                            {{ item.isAdHoc ? '-' : item.product.code }}
                        </template>


                        <template v-slot:[`item.product_description`]="{ item }" >
                            {{ item.override_product_description ? item.override_product_description : item.product.description }}
                        </template>

                        <!-- <template v-slot:[`item.product_description`]="{ item }" >
                            {{ (item.product_id ?? 0) == 0 ? item.override_product_description : item.product.description }}
                        </template> -->

                        
                        <!-- <template v-slot:[`item.total_price`]="{ item }" >
                            {{ item.total_price.toFixed(2) }}
                        </template> -->

                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
                            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
                        </template>
                    </v-data-table>

                    
                </v-card-text>

            </v-window-item>

            <v-window-item :value="3">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Παρατηρήσεις - Σχόλια</h3>

                    <v-text-field
                        v-model="comments"
                        label="Παρατηρήσεις">
                    </v-text-field>

                    <v-textarea
                        v-model="comments2"
                        label="Σχόλια">
                    </v-textarea>
                    
                </v-card-text>

            </v-window-item>

            <v-window-item :value="4">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Συνοψη παραστατικού</h3>
                    
                    <v-text-field
                        readonly 
                        v-model="selectedDocumentType.description" 
                        label="Παραστατικό">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="document_issue_date" 
                        label="Ημερομηνία">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="supplier.name" 
                        label="Προμηθευτής">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="totalChargedAmountSummary" 
                        label="Καθαρές χρεώσεις">
                    </v-text-field>

                    <div class="text-center">
                        <v-btn 
                            color="success" 
                            @click="saveDocument" 
                            v-bind:loading="saveDocumentButtonDisabled">
                            ΑΠΟΘΗΚΕΥΣΗ
                        </v-btn>
                    </div>
                </v-card-text>

            </v-window-item>


        </v-window>

        <v-card-actions>
            <v-btn
                v-bind:disabled="step <= 0"
                text
                v-on:click="step--"
                color="primary">
                ΠΙΣΩ
            </v-btn>
            <v-spacer></v-spacer>
            <v-item-group
                v-model="step"
                class="text-center"
                mandatory>
                <v-item
                        v-for="n in totalSteps"
                        v-bind:key="`btn-${n}`"
                        v-slot="{ active, toggle }">
                    <v-btn
                        v-bind:input-value="active"
                        icon
                        dense
                        x-small
                        disabled
                        @click="toggle">
                        <v-icon color="blue">mdi-record</v-icon>
                    </v-btn>
                </v-item>
            </v-item-group>

            <v-spacer></v-spacer>
            <v-btn
                v-bind:disabled="(step >= totalSteps - 1) || (stepCompleted == false)"
                color="primary"
                depressed
                @click="scroll2top(); step++;">
                ΕΠΟΜΕΝΟ
            </v-btn>
        </v-card-actions>


    </v-card>

</template>

<script>
import goTo from 'vuetify/lib/services/goto'
import currency from "currency.js"

export default {
    data () {
        return {
            moneyFieldOptions: {
                locale: "el-GR",
                prefix: "€",
                suffix: "",
                length: 12,
                precision: 4
            },

            discountFieldOptions: {
                locale: "el-GR",
                prefix: "",
                suffix: "%",
                length: 4,
                precision: 2
            },

            step: 0,
            totalSteps: 5,
            menu2: false,
            saveDocumentButtonDisabled: false,
            
            allerrors : {
                supplier: {},
            },

            documentTypes: [],
            documentSeries: [],
            taxOffices: [],
            countries: [],
            paymentTypes: [],
            charges: [],

            warehouses: [],
            selectedWarehouse: null,


            products: [],
            vatCategories: [],
            measurementUnits: [],
            incomeCategories: [],
            vatExemptionCategories: [],

            productLines: [],

            selectedDocumentType: {
                series: [],
                charges: []
            },

            selectedSeries: {},

            filteredDocumentSeries: [],

            document_number: '',
            document_issue_date: '',
            document_id: null,
            duplicateWarning: '',
            checkDuplicateTimeout: null,

            comments: '',
            comments2: '',
            supplier: {},
            

            selectedPaymentType: {},

            dialog: false,
            dialogDelete: false,
            selectAccountDialog: false,
            selectAccountDialogEntries: [],
            selectAccountDialogShownFor: '',

            items: [],
            itemsHeaders: [
                {
                    text: 'Κωδικός',
                    value: 'product_code',
                    align: 'start'
                },
                {
                    text: 'Περιγραφή',
                    value: 'product_description',
                    align: 'start'
                },
                {
                    text: 'Ποσότητα',
                    value: 'quantity',
                    align: 'start'
                },
                {
                    text: 'Καθαρή αξία',
                    value: 'total_price',
                    align: 'start'
                },
                {
                    text: 'Έκπτωση',
                    value: 'discount',
                    align: 'start'
                },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            formTitle: '',
            editedItem: {},
            editedIndex: -1,
            defaultItem: {
                isAdHoc: false,
                quantity: 0,
                unit_price: 0,
                total_price: 0,

                override_product_vat_category_id : null,
                override_product_tax_withholding_category_id: null,
                override_product_income_category_id: null,
                override_product_measurement_unit_id: null
            },

            disabledTaxRegistrationNumberFields : {
                supplier: false
            }
        }
    },

    created() {
        this.initialize()
    },

    watch: {
        selectedDocumentType: function (val) {
            this.document_number = ''
            this.selectedSeries = {}

            if (this.selectedDocumentType.series && this.selectedDocumentType.series.length == 1)
                this.selectedSeries = this.selectedDocumentType.series[0]

        },

        selectedProductId: function (newValue) {
            if (newValue)
            {
                console.log('firing')

                if (this.editedIndex > 0)
                {
                    console.log('skipping')
                    return
                }

                const payload = {
                    supplier_id: this.supplier.id,
                    product_id: newValue
                }

                axios.post('/api/pricing/purchase-price', payload)
                .then(response => {
                     this.editedItem.unit_price = response.data.price
                     this.editedItem.discount_percentage = response.data.discount_percentage
                })
                .catch(error => console.log(error))


            }
        },

        dialog: function (newValue) {
            if (newValue == false)
                this.editedItem = Object.assign({}, this.defaultItem)
        },

        document_number: function(newValue) {
            this.checkDuplicate();
        },
        
        'supplier.id': function(newValue) {
            this.checkDuplicate();
        }

    },

    computed: {

        totalItemsCount() {
            return this.items.map(x => x.quantity).reduce((a, b) => a+b, 0)
        },

        selectedProductId() {
            if (this.editedItem == null)
                return null

            return this.editedItem.product_id
        },

        filteredSupplierCities() { return [] },
        
        selectedDocumentTypeDescription () { 
            if (this.document_type_id && this.documentTypes.length > 0)
                return this.documentTypes.find(x => x.id == this.document_type_id).description

            return ''
        },

        selectedDocumentTypeIsPayable() {
            return (this.selectedDocumentType.payable == true);
        },

        totalChargedAmount() {
            const reducer = (a, b) => (currency(a).add(b))

            return this.round2(this.items.map(x => x.total_price - x.discount).reduce(reducer, 0.0).value)
        },

        filteredPaymentTypes() {
            if (this.selectedDocumentType && (this.selectedDocumentType.id ?? 0) > 0) {
                // console.log(`selected document inert: ${selectedDocumentType.inert}`)

                if (this.selectedDocumentType.updates_ledger == false)
                    return this.paymentTypes.filter(x => x.flag_credit == true)
                
                return this.paymentTypes
            }
                
        },
        
        totalChargedAmountSummary() {
            
            let chargedAmount = this.totalChargedAmount

            if (this.selectedPaymentType && chargedAmount)
                return `(${this.selectedDocumentType.payable ? this.selectedPaymentType.description : "ΠΙΣΤΩΣΗ"}) ${chargedAmount}`
        },

        stepCompleted() {
            switch (this.step) {
                case 0:
                    if (!this.selectedDocumentType.id)
                        return false
                    
                    if (!this.document_issue_date)
                        return false

                    if (this.document_number.toString().length > 0 == false)
                        return false

                    if (!this.selectedWarehouse)
                        return false
                    
                    break

                case 1:
                    if ((this.supplier.name ?? '').length > 1 == false)
                        return false

                    if ((this.supplier.country_id ?? 0) > 0 == false)
                        return false
                    
                    if ((this.supplier.city ?? '').length > 1 == false)
                        return false

                    if ((this.supplier.address ?? '').length > 1 == false)
                        return false
                    
                    break

                case 2:
                    if (this.selectedDocumentType.payable == true && ((this.selectedPaymentType.id ?? 0 > 0) == false))
                        return false

                    if (this.totalChargedAmount > 0 == false)
                        return false

                    break

                default:
                    return true
            }
        },

        supplierNotEditable() {
            return (this.supplier.id ?? 0) > 0
        },

        lineEntryIncomplete() {
            let isLineOk = 
                ((this.editedItem.quantity ?? 0) > 0) 
                && ((this.editedItem.unit_price ?? 0) > 0)
                && (
                    (
                        (this.editedItem.product_id ?? 0 > 0)
                        || (
                                (this.editedItem.product_id ?? 0 == 0)
                                && this.editedItem.override_product_description?.length > 0
                                && this.editedItem.override_product_vat_category_id > 0
                                && this.editedItem.override_product_measurement_unit_id > 0
                            )
                    )
                )
                
            return isLineOk == false;
        },
    },


    methods: {

        productSelected(newValue) {
            const product = this.products.find(x => x.id == newValue)

            this.editedItem.override_product_description = product.description
            this.editedItem.override_product_vat_category_id = product.vat_category_id
            this.editedItem.override_product_measurement_unit_id = product.measurement_unit_id
            this.editedItem.override_product_vat_exemption_category_id = product.vat_exemption_category_id ?? 0
            this.editedItem.override_product_tax_withholding_category_id = product.tax_withholding_category_id ?? 0
            this.editedItem.override_product_income_category_id = product.income_category_id
        },

        adHocItemStatusChanged(newValue) {
            // this.editedItem = {
            //     ...this.defaultItem,
            //     isAdHoc: newValue
            // }

        },


        mixmatch (item) {
            // if (item.isAdHoc)
            //     item.product_id = 0

            if (item.product_id > 0)
                item.product = this.products.find(prd => prd.id == item.product_id)
            else
                item.product = {
                  code: '-',
                  description: item.override_product_description  
                }
                
            item.discount = 0

            item.total_price = this.round2(item.quantity * item.unit_price)

            if (item.discount_percentage > 0)
                item.discount = this.round2(item.total_price * (item.discount_percentage * 0.01))


            return item;
        },

        round2(number) {
            const rounded = Math.round( number * 100 + Number.EPSILON ) / 100

            return rounded.toFixed(2)
        },

        scroll2top() {
            goTo(0)
        },

        clearSupplierFields() {
            this.supplier = {}
        },

        initialize() {
            this.$store.dispatch('currentUser/getCurrentUser')
            
            this.document_id = this.$route.params.id;

            const dateAthens = new Intl.DateTimeFormat('en-CA', {
                timeZone: 'Europe/Athens',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).format(new Date());

            this.document_issue_date = dateAthens;

            axios.all([
                axios.get('/api/document-types/purchases'),
                axios.get('/api/tax-offices'),
                axios.get('/api/countries'),
                axios.get('/api/tax-authority/payment-types'),
                axios.get('/api/products'),
                axios.get('/api/tax-authority/vat-categories'),
                axios.get('/api/measurement-units'),
                axios.get('/api/vat-exemption-categories'),
                axios.get('/api/income-categories'),
                axios.get('/api/warehouses')
            ]).then(
                axios.spread(
                (
                    documentTypesResponse, 
                    taxOfficesResponse, 
                    countriesResponse, 
                    paymentTypesResponse,
                    productsResponse,
                    vatCategoriesResponse,
                    measurementUnitsResponse,
                    vatExemptionCategoriesResponse,
                    incomeCategoriesResponse,
                    warehousesResponse
                ) => {
                    this.documentTypes = documentTypesResponse.data.sort(
                        (a, b) => a.debit === b.debit ? a.description.localeCompare(b.description) : (a.debit ? -1 : 1)
                    )
                    
                    this.taxOffices = taxOfficesResponse.data.sort((a, b) => a.name.localeCompare(b.name))
                    this.countries = countriesResponse.data
                    this.paymentTypes = paymentTypesResponse.data
                    this.vatCategories = vatCategoriesResponse.data
                    this.measurementUnits = measurementUnitsResponse.data
                    this.vatExemptionCategories = vatExemptionCategoriesResponse.data
                    this.incomeCategories = incomeCategoriesResponse.data

                    this.warehouses = warehousesResponse.data

                    if (this.warehouses.length == 1)
                        this.selectedWarehouse = this.warehouses[0]

                    this.products = productsResponse.data.map( 
                        function (product) { 
                            product.text = `${product.code} | ${product.description}`
                            product.suggested_price = 0
                            return product
                        })
                        
                    this.fetchDocument();

            })).catch(error => { console.log(error) })

            this.editedItem = Object.assign({}, this.defaultItem)
        },
        
        fetchDocument() {
            axios.get(`/api/documents/purchases/${this.document_id}`)
                .then(response => {
                    const doc = response.data;
                    this.selectedDocumentType = this.documentTypes.find(dt => dt.id == doc.document_type_id) || {};
                    
                    this.$nextTick(() => {
                        this.document_issue_date = doc.issue_date ? doc.issue_date.split(' ')[0] : '';
                        this.document_number = doc.document_number;
                        this.selectedWarehouse = this.warehouses.find(w => w.id == doc.warehouse_id) || {};
                        this.selectedPaymentType = this.paymentTypes.find(pt => pt.id == doc.payment_type_id) || {};
                        this.comments = doc.comments;
                    });
                    
                    if (doc.customer) {
                        this.updateAccount('supplier', doc.customer);
                    }
                    
                    if (doc.lines && doc.lines.length > 0) {
                        this.items = doc.lines.map(line => {
                            let mappedLine = {
                                product_id: line.product_id,
                                quantity: line.quantity,
                                unit_price: Number(line.net_value) / Number(line.quantity),
                                discount_percentage: line.discount_percentage || 0,
                                discount: line.discount_value,
                                total_price: line.net_value,
                                isAdHoc: false
                            };
                            
                            if (line.product_id == null || line.product_id == 0) {
                                mappedLine.isAdHoc = true;
                                mappedLine.product_id = 0;
                                mappedLine.override_product_description = line.override_product_description; // might need adjustment depending on db schema
                            } else if (line.product) {
                                mappedLine.product = line.product;
                            }
                            
                            return mappedLine;
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({ icon: 'error', title: 'Σφάλμα', text: 'Αδυναμία φόρτωσης παραστατικού' });
                });
        },


        editItem (item) {
            console.log(item)
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        deleteItem (item) {
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm () {
            this.items.splice(this.editedIndex, 1); 
            this.closeDelete();
        },

        close () {
            this.dialog = false
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1

            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        closeDelete () {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save (closeDialog = true) {
            if (this.editedIndex > -1) {
                Object.assign(this.items[this.editedIndex], this.mixmatch(this.editedItem)); 
            } else {
                this.items.push(this.mixmatch(this.editedItem));
            }

            if (closeDialog)
                this.close();
            else
                this.editedItem = Object.assign({}, this.defaultItem)


            this.editedIndex = -1
            
        },


        saveDocument() {
            this.saveDocumentButtonDisabled = true;

            let requestBody = {
                document_type_id: this.selectedDocumentType.id,
                document_issue_date: this.document_issue_date,
                document_number: this.document_number,
                warehouse_id: this.selectedWarehouse.id,
                supplier: this.supplier,
                
                payment_type_id: this.selectedDocumentTypeIsPayable ? this.selectedPaymentType.id : this.paymentTypes.find(x => x.flag_credit == true).id,
                productLines: this.items.map(x => {
                    let productLine = { 
                        product_id : x.product_id, 
                        quantity: x.quantity, 
                        unit_price: x.unit_price,
                        discount: x.discount,
                        discount_percentage: x.discount_percentage,
                        total_price: x.total_price
                    } 

                    if (x.product_id > 0 && x.isAdHoc == false)
                        return productLine

                    let adhocProductLine = {
                        ...productLine,
                        override_product_description: x.override_product_description,
                        override_product_vat_category_id: x.override_product_vat_category_id,
                        override_product_measurement_unit_id: x.override_product_measurement_unit_id,
                    }

                    adhocProductLine.product_id = 0

                    return adhocProductLine;
                }),
                comments: (this.comments && this.comments.length > 0) ? this.comments : null,
            }

            axios.patch(`/api/documents/purchases/${this.document_id}`, requestBody)
            .then(_ => { 
                this.$router.push({ name: 'purchasedocuments' })
            })
            .catch(error => { 
                console.log(error)
                if (error.response && error.response.data) {
                    if (error.response.data.errors) {
                        const errs = { supplier: {} }
                        for (const [key, val] of Object.entries(error.response.data.errors)) {
                            const parts = key.split('.')
                            if (parts.length === 2) {
                                if (!errs[parts[0]]) errs[parts[0]] = {}
                                errs[parts[0]][parts[1]] = val
                            } else {
                                errs[key] = val
                            }
                        }
                        this.allerrors = errs
                        const messages = Object.values(error.response.data.errors).flat().join('<br>')
                        this.$swal({ icon: 'error', title: 'Σφάλμα', html: messages })
                    } else if (error.response.data.message) {
                        this.$swal({ icon: 'error', title: 'Σφάλμα', text: error.response.data.message })
                    }
                }
              })
            .finally( () => { this.saveDocumentButtonDisabled = false })
        },

        async searchAccountByTaxRegistrationNumber(accountPropertyName) {

            if (this.disabledTaxRegistrationNumberFields[accountPropertyName] == true)
                return

            this.disabledTaxRegistrationNumberFields[accountPropertyName] = true

            let needle = this[accountPropertyName].tax_registration_number
            let response = await axios.get(`/api/accounts/search/tax-registration-number/${needle}`)

            this.disabledTaxRegistrationNumberFields[accountPropertyName] = false
            
            if (response.data.length == 1) {
                let account = response.data[0]

                this.updateAccount(accountPropertyName, account)
                
                if (this.taxOffices.filter(taxOffice => taxOffice.code == account.tax_office.code).length > 0 == false) {
                    //this.taxOffices.push(account.tax_οffice)
                    axios.get('/api/tax-offices')
                    .then(response => this.taxOffices = response.data)
                }
            } else if (response.data.length > 1) {
                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
            
        },

        async searchAccountByName(accountPropertyName) {
            let needle = this[accountPropertyName].name
            let response = await axios.get(`/api/accounts/search/name/${needle}`)

            if (response.data.length == 1)
                this.updateAccount(accountPropertyName, response.data[0])
            else if (response.data.length > 1) {

                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
        },

        closeSelectAcountDialog() {
            this.selectAccountDialog = false
            this.selectAccountDialogEntries = []
            this.selectAccountDialogShownFor = null
        },

        updateAccount(accountPropertyName, data) {
            this[accountPropertyName] = {
                id: data.id,
                address : data.address,
                name : data.name,
                city : data.city,
                telephone : data.telephone,
                fax : data.fax,
                email : data.email,
                country_id : data.country_id,
                mobile : data.mobile,
                tax_registration_number: data.tax_registration_number,
                zipcode: data.zipcode,
                tax_registration_office_id: data.tax_registration_office_id,
                jobtitle: data.jobtitle
            }

            if (data.discount_percentage > 0)
            {
                const percentage = parseFloat(data.discount_percentage)
                this.defaultItem.discount_percentage = percentage
                this.editedItem.discount_percentage = percentage
            }
        },

        checkDuplicate() {
            if (this.checkDuplicateTimeout) {
                clearTimeout(this.checkDuplicateTimeout);
            }
            
            if (!this.supplier.id || !this.document_number) {
                this.duplicateWarning = '';
                return;
            }
            
            this.checkDuplicateTimeout = setTimeout(() => {
                axios.get('/api/documents/purchases/check-exists', {
                    params: {
                        supplier_id: this.supplier.id,
                        document_number: this.document_number,
                        document_issue_date: this.document_issue_date,
                        exclude_id: this.document_id || null
                    }
                }).then(response => {
                    if (response.data.exists) {
                        this.duplicateWarning = 'Υπάρχει ήδη παραστατικό με αυτόν τον αριθμό για τον συγκεκριμένο προμηθευτή!';
                    } else {
                        this.duplicateWarning = '';
                    }
                }).catch(error => console.log(error));
            }, 500);
        }
    }
}
</script>

<style scoped>

</style>